import { Element } from 'slate';
import { ListType } from "../types.js";
/**
 * Returns the "type" of a given list node.
 */
export function getListType(editor, node) {
  var isElement = Element.isElement(node);
  if (isElement && editor.isListNode(node, ListType.ORDERED)) {
    return ListType.ORDERED;
  }
  if (isElement && editor.isListNode(node, ListType.UNORDERED)) {
    return ListType.UNORDERED;
  }

  // This should never happen.
  return ListType.UNORDERED;
}